import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import _ from 'lodash';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { ToastComponent } from './components/toast/toast.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { AuthInterceptor } from './helpers/auth.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { ErrorHandlerInterceptor } from './helpers/error-handler.interceptor';
import { forkJoin, map, Observable } from 'rxjs';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { FrameModule } from './pages/frame/frame.module';
import { AuthGuard } from './helpers/auth.guard';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './utils/strategies/title.strategy';
import { QrDrawerComponent } from './components/drawers/qr-drawer/qr-drawer.component';

export function HttpLoaderFactory(http: HttpClient) {
  return {
    getTranslation: (lang: string): Observable<any> => {
      const files = [
        `./assets/i18n/main/${lang}.json`,
        `./assets/i18n/errors/${lang}-errors.json`,
        `./assets/i18n/prime/${lang}-prime.json`,
      ];
      return forkJoin(files.map(file => http.get(file))).pipe(
        map(responses => responses.reduce((acc, res) => ({ ...acc, ...res }), {}))
      );
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FrameModule,
    ToastComponent,
    ButtonModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    LoggerModule.forRoot({level: environment.logLevel}),
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    LoggerModule,
  ],
  providers: [
    AuthGuard,
    JwtHelperService,
    CookieService,
    MessageService,
    ConfirmationService,
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
          preset: Aura,
          options: {
            darkModeSelector: false || 'none'
          }
      }
    }),
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideHttpClient(
      withInterceptors([ErrorHandlerInterceptor]),
    ),
    { provide: TitleStrategy, useClass: AppTitleStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
